export const SENDMESSAGE = "SENDMESSAGE";
export const SENDMESSAGE_SUCCESS = "SENDMESSAGE_SUCCESS";
export const SENDMESSAGE_ERROR = "SENDMESSAGE_ERROR";



// WEBPACK FOOTER //
// ./src/store/actions/send.js